import { createReducer } from '../utils'

export const OFFSET = 'sherrinford/sidebar/OFFSET'
export const OPTIONS = 'sherrinford/sidebar/OPTIONS'

const initialStates = {
  offset: 0,
  options: {
    speed: 500,
    minDuration: 250,
    maxDuration: 3000,
    cancelOnUserAction: true,
  },
}

export default createReducer(initialStates, {
  [OFFSET]: (state, offset) => ({
    ...state,
    offset,
  }),
  [OPTIONS]: (state, options) => ({
    ...state,
    options,
  }),
})

export const setOffset = offset => ({
  type: [OFFSET],
  payload: offset,
})

export const setOptions = options => ({
  type: [OPTIONS],
  payload: options,
})
